import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Çağlayan Mahallesi Halı Yıkama",
    path: "/kagithane/caglayan-hali-yikama",
    description:
      "Kağıthane Çağlayan Mahallesi’nde halılarınız hijyenik ve garantili şekilde temizlenip kısa sürede teslim edilir."
  },
  {
    label: "Merkez Mahallesi Halı Yıkama",
    path: "/kagithane/merkez-hali-yikama",
    description:
      "Kağıthane Merkez Mahallesi’nde halı yıkama hizmetimiz profesyonel sistemlerle hızlı ve güvenli şekilde sunulur."
  },
  {
    label: "Gültepe Mahallesi Halı Yıkama",
    path: "/kagithane/gultepe-hali-yikama",
    description:
      "Gültepe Mahallesi’nde halılarınız antibakteriyel ürünlerle zarar vermeden yıkanır, steril şekilde paketlenir."
  },
  {
    label: "Ortabayır Mahallesi Halı Yıkama",
    path: "/kagithane/ortabayir-hali-yikama",
    description:
      "Ortabayır Mahallesi’nde halı yıkama ihtiyaçlarınızı kapıdan alım ve garantili teslimatla karşılıyoruz."
  },
  {
    label: "Talatpaşa Mahallesi Halı Yıkama",
    path: "/kagithane/talatpasa-hali-yikama",
    description:
      "Talatpaşa Mahallesi’nde tam otomatik makinelerde yapılan halı temizliğiyle sağlıklı ve hızlı hizmet veriyoruz."
  },
  {
    label: "Nurtepe Mahallesi Halı Yıkama",
    path: "/kagithane/nurtepe-hali-yikama",
    description:
      "Nurtepe Mahallesi’nde bireysel ve ticari halılarınız için uzman ekiple hijyenik çözümler sunuyoruz."
  },
  {
    label: "Hamidiye Mahallesi Halı Yıkama",
    path: "/kagithane/hamidiye-hali-yikama",
    description:
      "Hamidiye Mahallesi’nde çevre dostu ve kaliteli halı yıkama hizmetimiz kapıdan alım ve teslimat içerir."
  }
];

const KagithaneSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">KAĞITHANE SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KagithaneSidebar;
